<template>
  <transition name="fade">
    <div v-if="items.length" class="position-relative slides">
      <hooper-container
        class="slides-container"
        style="height: auto"
        ref="carousel"
        :wheelControl="false"
        :mouseDrag="items.length > 1"
        :touchDrag="items.length > 1"
        :infiniteScroll="items.length > 1"
        @slide="updateCarousel"
      >
        <hooper-slide
          class="item"
          v-for="({ img_desktop, img_mobile, link, target }, keySlide) in items"
          :key="keySlide"
        >
          <a v-if="link" :href="link" :target="target ? '_blank' : '_self'">
            <img
              :src="files + (xsOnly && img_mobile ? img_mobile : img_desktop)"
              class="d-block item-img"
              width="100%"
            />
          </a>

          <img
            v-else
            :src="files + (xsOnly && img_mobile ? img_mobile : img_desktop)"
            class="d-block item-img"
            width="100%"
          />
        </hooper-slide>
      </hooper-container>

      <div
        v-if="items.length > 1"
        class="d-flex justify-space-between px-3 px-md-4 px-lg-5 slides-nav"
      >
        <a
          class="d-flex align-center justify-center pr-1 slides-nav-item"
          @click.prevent="slidePrev"
        >
          <v-icon color="white" :size="xsOnly ? 30 : 40">
            fa-angle-left
          </v-icon>
        </a>
        <a
          class="d-flex align-center justify-center pl-1 slides-nav-item"
          @click.prevent="slideNext"
        >
          <v-icon color="white" :size="xsOnly ? 30 : 40">
            fa-angle-right
          </v-icon>
        </a>
      </div>
    </div>
  </transition>
</template>

<script>
const _config = {
  mod: "banners",
};

export default {
  data: () => ({
    carouselData: 0,
  }),
  created() {
    this.$rest(_config.mod).get();
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
    updateCarousel(payload) {
      this.myCarouselData = payload.currentSlide;
    },
  },
  watch: {
    carouselData() {
      this.$refs.carousel.slideTo(this.carouselData);
    },
  },
};
</script>

<style lang="scss" scoped>
.slides {
  aspect-ratio: 1920 / 470;

  @media screen and (max-width: 600px) {
    aspect-ratio: 600 / 600;
  }

  .item {
    &-img {
      aspect-ratio: 1920 / 470;
      object-fit: cover;
      -o-object-fit: cover;

      @media screen and (max-width: 600px) {
        aspect-ratio: 600 / 600;
      }
    }
  }

  &-nav {
    height: 0;
    left: 0;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 100%;

    @media screen and (max-width: 600px) {
      margin-top: -20px;
    }

    &-item {
      border-radius: 50%;
      height: 50px;
      width: 50px;
      @media screen and (max-width: 600px) {
        height: 40px;
        width: 40px;
      }
    }
  }
}

.slides-container::v-deep {
  ol,
  ul {
    padding-left: 0 !important;
  }
}
</style>
